import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionsService } from '../services/permissions.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard {
  
  constructor(
    private router: Router,
    private permissionsService: PermissionsService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    // Obtener el permiso requerido desde la ruta
    const requiredPermission = route.data['permission'] as string;
    
    if (!requiredPermission) {
      return true;
    }

    // Verificar si el usuario tiene el permiso
    if (this.permissionsService.hasPermission(requiredPermission)) {
      return true;
    } else {
      // Redirigir al dashboard si no tiene permisos
      this.router.navigate(['/app/dashboard']);
      return false;
    }
  }
} 